// extracted by mini-css-extract-plugin
module.exports = {"m11mcrga":"m11mcrga","footnote":"footnote","bordered":"bordered","sticky":"sticky"};